
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import Footer from '/home/circleci/app/packages/layout-footer-component/src/entries/Default';

const element = typeof document !== 'undefined' && document.querySelector('#Footer');
if (element) {
    const props = window.initialData['Footer'];
    ReactDOM.hydrate(
        <Footer {...props}/>,
        element
    );
}
export default Footer;
